import PagedElements from '@/models/paged/pagedelements';
import RankListViewInterface from '@/models/view/ranklistviewmodel';

export default class PagedRanks extends PagedElements<RankListViewInterface> {
    constructor(init?: Partial<PagedRanks>) { super(init); }
}
